module.exports = __webpack_public_path__ + "img/honour3.4a1ad44a.png";